import { render } from "./UserPolicy.vue?vue&type=template&id=cff758ea"
import script from "./UserPolicy.vue?vue&type=script&lang=js"
export * from "./UserPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__